import SubscribeForm from "@/components/feature/SubscribeForm";
import { site } from "@/mocks/site";

export default function ContactSection() {
  return (
    <section id="contact" className="w-full px-4 md:px-10 py-16 md:py-24">
      <div className="relative rounded-lg overflow-hidden bg-secondary-900">
        <div className="absolute inset-0 opacity-30">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20abstract%20flowing%20amber%20and%20coral%20light%20ribbons%20over%20deep%20terracotta%20background%2C%20soft%20editorial%20texture%2C%20cinematic%20gradient%2C%20no%20people%2C%20no%20text&width=1600&height=700&seq=cta-guatan-01&orientation=landscape"
            alt="诱惑吃瓜 订阅区域背景装饰"
            title="订阅最新瓜线"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="relative px-6 py-12 md:px-14 md:py-16 max-w-3xl">
          <span className="inline-flex items-center gap-1.5 text-xs font-medium tracking-widest text-accent-300 bg-accent-500/15 px-3 py-1 rounded-full">
            <i className="ri-notification-3-line w-4 h-4 flex items-center justify-center"></i>
            别错过后续
          </span>
          <h2 className="mt-4 text-2xl md:text-4xl font-bold text-background-50 leading-snug">
            订阅围观提醒，反转第一时间发你
          </h2>
          <p className="mt-4 text-sm md:text-base text-secondary-200 leading-relaxed">
            每天精选 3 条最值得追的瓜线，附时间线与最新进展。也可以直接给我们写信：
            <a href={`mailto:${site.email}`} className="text-accent-300 hover:text-accent-200 ml-1">
              {site.email}
            </a>
          </p>
          <div className="mt-8 max-w-xl">
            <SubscribeForm variant="dark" />
          </div>
        </div>
      </div>
    </section>
  );
}